import React from "react";

import { MarginaliaGroup } from "../../../components/ContentBuilder/MarginaliaGroup/MarginaliaGroup";
import { MarginaliaTitle } from "../../../components/ContentBuilder/MarginaliaTitle/MarginaliaTitle";
import { MarginaliaButton } from "../../../components/ContentBuilder/MarginaliaButton/MarginaliaButton";
import { MarginaliaList } from "../../../components/ContentBuilder/MarginaliaList/MarginaliaList";
import { MarginaliaData } from "../../../components/ContentBuilder/ContentBuilder.type";

import { downloadTopicPdf } from "./downloadFile";

// Topic PDF in public/files/pdf; the download button is hidden while this is undefined.
const TOPIC_PDF_FILENAME: string | undefined = "applia-home-appliance-monitor-2025-recycling.pdf";

export const recyclingPageMarginalia: MarginaliaData = {
	component: MarginaliaGroup,
	props: {
		children: [
			<MarginaliaTitle key="on-this-page-title" title="On this page" />,
			<MarginaliaList
				key="on-this-page-list"
				items={[
					{
						label: "Hoarding of WEEE",
						scrollTo: "recycling-hoarding-weee",
					},
					{
						label: "Collected WEEE",
						scrollTo: "recycling-collection-weee",
					},
					{
						label: "WEEE collected and other non-compliant flows",
						scrollTo: "recycling-weee-non-compliant-flows",
					},
					{
						label: "WEEE flows in the home appliance sector",
						scrollTo: "recycling-weee-flow-text-chart",
					},
					{
						label: "Routes of recycled plastics",
						scrollTo: "recycling-routes-of-recycled-plastic"
					}
				]}
			/>,
			<div key="topic-download-spacer" className="mt-3">
				<MarginaliaTitle title="Topic download" />
			</div>,
			...(TOPIC_PDF_FILENAME ? [<MarginaliaButton key="download" variant="download" icon="document" label="Recycling" sublabel="PDF" onClick={() => downloadTopicPdf(TOPIC_PDF_FILENAME)} />] : []),
			<MarginaliaButton key="copy" variant="copy" label="Copy link to this topic" clickedLabel="Link copied" onClick={() => navigator.clipboard.writeText(window.location.href)} />,
		],
	},
};
